var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.inEdit)?_c('div',{staticClass:"text-sm text-neutral-600"},[_vm._v(" This field will remain unchanged and it will not have any effect on the anonymisation algorithm. ")]):_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }